import { render, staticRenderFns } from "./ShipInfo.vue?vue&type=template&id=7450484c"
import script from "./ShipInfo.vue?vue&type=script&lang=js"
export * from "./ShipInfo.vue?vue&type=script&lang=js"
import style0 from "./ShipInfo.vue?vue&type=style&index=0&id=7450484c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports